module.exports = __webpack_public_path__ + "img/cookie_bird.e8a6dea2.svg";